import { useEffect, useState } from 'react';
import { Table, Typography, Tag, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

const { Text } = Typography;

export default function PaymentsPage() {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = () => {
        setLoading(true);
        api.get('/tariffs/admin/payments').then(res => {
            setPayments(res.data.data || []);
        }).catch(err => console.error(err)).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
        { title: 'Biznes', dataIndex: 'business_name', key: 'biz', render: (v) => <Text strong>{v}</Text> },
        { title: 'Xizmat', dataIndex: 'service_name', key: 'svc' },
        { title: 'Xizmat turi', dataIndex: 'service_type_name', key: 'type', render: (v) => <Tag color="blue">{v}</Tag> },
        {
            title: 'Summa', dataIndex: 'amount', key: 'amount', width: 150,
            render: (v) => <Text strong style={{ color: '#52c41a' }}>{Number(v).toLocaleString()} so'm</Text>,
        },
        {
            title: 'Muddat', key: 'period', width: 220,
            render: (_, r) => (
                <span>{String(r.paid_from).slice(0, 10)} &rarr; {String(r.paid_to).slice(0, 10)}</span>
            ),
        },
        {
            title: 'Holat', dataIndex: 'status', key: 'status', width: 100,
            render: (v, r) => {
                const isExpired = new Date(r.paid_to) < new Date();
                if (v === 'active' && !isExpired) return <Tag color="green">Aktiv</Tag>;
                if (isExpired) return <Tag color="red">Muddati o'tgan</Tag>;
                return <Tag>{v}</Tag>;
            },
        },
        {
            title: 'Sana', dataIndex: 'created_at', key: 'date', width: 140,
            render: (v) => v ? String(v).slice(0, 16).replace('T', ' ') : '—',
        },
    ];

    return (
        <div>
            <div className="admin-toolbar">
                <span style={{ color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{payments.length}</b> to'lov</span>
                <Button icon={<ReloadOutlined />} onClick={load} style={{ marginLeft: 'auto' }}>Yangilash</Button>
            </div>
            <div className="admin-table-card">
                <Table
                    dataSource={payments}
                    columns={columns}
                    rowKey="id"
                    loading={loading}
                    pagination={payments.length > 20 ? { pageSize: 20 } : false}
                    size="middle"
                    scroll={{ x: 800 }}
                />
            </div>
        </div>
    );
}
